module.exports = __webpack_public_path__ + "media/components/assets/icons/sharing-846570e0b8dd599afb15a6ddd13a00ca.svg";